// @ts-nocheck

;(function () {
  // Only run on non-touch devices
  const isTouchDevice =
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    window.matchMedia('(pointer: coarse)').matches
  if (isTouchDevice) return

  const el = document.getElementById('footerLogoText')
  if (!el) return

  const chars = Array.from(el.querySelectorAll('.footer-text-char'))
  if (chars.length < 2) return

  let offsets = []

  function computeOffsets() {
    chars.forEach((ch) => (ch.style.transform = 'translateX(0px)'))

    const cRect = el.getBoundingClientRect()
    const cW = cRect.width

    const currentX = chars.map((ch) => ch.getBoundingClientRect().left - cRect.left)
    const widths = chars.map((ch) => ch.getBoundingClientRect().width)

    const targetX = chars.map((_, i) => {
      if (i === 0) return 0
      if (i === chars.length - 1) return cW - widths[i]
      return (cW - widths[i]) * (i / (chars.length - 1))
    })

    offsets = targetX.map((tx, i) => tx - currentX[i])

    // ✅ keep the 2nd character fixed
    if (offsets.length > 1) offsets[1] = 0

    if (el.classList.contains('is-spread')) apply(true, true)
  }

  function apply(spread, immediate = false) {
    if (!offsets.length) return

    if (immediate) {
      // avoid “jump” during resize recompute
      chars.forEach((ch) => (ch.style.transition = 'none'))
      requestAnimationFrame(() => {
        chars.forEach((ch, i) => {
          ch.style.transform = spread ? `translateX(${offsets[i]}px)` : 'translateX(0px)'
        })
        requestAnimationFrame(() => {
          chars.forEach((ch) => (ch.style.transition = ''))
        })
      })
      return
    }

    chars.forEach((ch, i) => {
      ch.style.transform = spread ? `translateX(${offsets[i]}px)` : 'translateX(0px)'
    })
  }

  computeOffsets()
  window.addEventListener('resize', computeOffsets)

  let opened = false

  function viewportHeight() {
    return window.visualViewport?.height || window.innerHeight
  }

  const io = new IntersectionObserver(
    ([entry]) => {
      if (!entry) return

      const vh = viewportHeight()
      const r = entry.boundingClientRect

      const fullyOut = r.bottom <= 0 || r.top >= vh

      // Fully in view-ish (avoid strict === 1)
      const fullyIn = entry.intersectionRatio >= 0.5

      if (fullyIn && !opened) {
        opened = true
        el.classList.add('is-spread')
        apply(true)
        return
      }

      if (opened && fullyOut) {
        opened = false
        el.classList.remove('is-spread')
        apply(false)
      }
    },
    {
      threshold: [0, 0.5],
    },
  )

  io.observe(el)
})()
